import { render, staticRenderFns } from "./date-formatter.vue?vue&type=template&id=811660a2"
import script from "./date-formatter.vue?vue&type=script&lang=js"
export * from "./date-formatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports